// src/components/modals/ImagePreviewModal.tsx
// Modal component for displaying image previews
import React from "react";
import "./ImagePreviewModal.css";

interface ImagePreviewModalProps {
  isOpen: boolean;
  imageSrc: string;
  imageAlt: string;
  title?: string;
  onClose: () => void;
}

export const ImagePreviewModal: React.FC<ImagePreviewModalProps> = ({
  isOpen,
  imageSrc,
  imageAlt,
  title,
  onClose,
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="image-preview-modal-overlay" onClick={handleOverlayClick}>
      <div className="image-preview-modal">
        <button className="image-preview-modal-close" onClick={onClose}>
          &times;
        </button>
        {title && <h3 className="image-preview-modal-title">{title}</h3>}
        <div className="image-preview-modal-content">
          <img src={imageSrc} alt={imageAlt} className="image-preview-modal-image" />
        </div>
      </div>
    </div>
  );
};

export default ImagePreviewModal;
